import type { SupportedLangCode } from '@/application/i18n/language'
import type { Investigation } from '@/domains/types'

type SluggedInvestigation = Pick<Investigation, 'id' | 'slugs' | 'sourceLocale'>

function isSupportedSlugLocale(locale: string | undefined): locale is SupportedLangCode {
  return locale === 'fr' || locale === 'en' || locale === 'es'
}

/**
 * Public URL segment of an investigation in one language: that language's
 * slug, else the source-language slug, else the UUID. The UUID is never a
 * broken link: the detail route redirects it to the real slug.
 */
export function investigationSlug(
  investigation: SluggedInvestigation,
  locale: SupportedLangCode,
): string {
  const { slugs, sourceLocale } = investigation
  const sourceSlug = isSupportedSlugLocale(sourceLocale) ? slugs?.[sourceLocale] : undefined
  return slugs?.[locale] ?? sourceSlug ?? investigation.id
}

/** Language-free public path (`/investigations/<slug>`). */
export function investigationPath(
  investigation: SluggedInvestigation,
  locale: SupportedLangCode,
): string {
  return `/investigations/${investigationSlug(investigation, locale)}`
}
